/* eslint-disable no-alert */
// import { rest } from "lodash";
import QRCode from 'qrcode';
import { stringFormat, getURLParameter, verityInput } from '@/utils/util-extent';

const { $ } = window;

// eslint-disable-next-line no-extend-native
String.prototype.format = stringFormat;


const cityHtml = '<option value="{city}">{city}</option>';
const areaHtml = '<option value="{area}">{area}</option>';
const salesHtml = `<div class="col-6 col-md-4 col-lg-3 show-less">
<a href="javascript:void(0)" data-Id={SNO} class="sale-link" data-fancybox="sale-data" data-src="#modal{SNO}" data-sales="{EMP_NO} {NAM}">
<article class="sale-item">
  {TOPview}
  <div class="sale-image-wrap">
  <img src="{IMG_LNK}" alt="{NAM}">
  </div>
  <div class="sale-content">
  <span class="sale-title pr-4">{NAM}</span><span>{BRANCHFULLNM}</span>
  </div>
</article>
</a>
<div id="modal{SNO}" class="sale-modal" name="{NAM}" style="display: none;">
<div class="sale-modal-content">
  <div class="sale-modal-scroll">
  <div class="scroll-hint">Scroll
  <img src="/images/cloud-sale/icon-arrow.svg" alt="箭頭"/>
  </div>
  <div class="sale-modal-img  d-none d-md-block">
    {CASEspec}
    <img src="{IMG_LNK}" alt="{NAM}">
    <div class="sale-modal-name-and-tag">
    <div class="sale-modal-name">
      <span class="name">{NAM}</span>
      <span class="pl-4 d-none d-md-inline">{TITLE}</span>
      <div class="d-md-none">{BRANCHFULLNM}
      {TITLE}</div>
    </div>
    <ol class="sale-modal-tag">
      {RENARKS}
    </ol>
    </div>
  </div>
  <div class="tab-container w-100">
    {CASEtabview}
    <div class="tab-content" id="tabContent{SNO}">
    <div class="tab-pane fade show active" id="about{SNO}" role="tabpanel" aria-labelledby="about-tab{SNO}">
    
    <div class="sale-modal-img d-block d-md-none">
      {CASEspec}
      <img src="{IMG_LNK}" alt="{NAM}">
      <div class="sale-modal-name-and-tag">
      <div class="sale-modal-name">
        <span class="name">{NAM}</span>
        <span class="pl-4 d-none d-md-inline">{TITLE}</span>
        <div class="d-md-none">{BRANCHFULLNM}
        {TITLE}</div>
      </div>
      <ol class="sale-modal-tag">
        {RENARKS}
      </ol>
      </div>
      </div>

      <div class="sale-modal-text">
      <div class="sale-modal-scroll-pc popup-scroll">
        <article>
        <header>服務據點</header>
        <div>
          <p class="mb-0">{DEALER} {BRANCHFULLNM}</p>
          <p class="mb-0">
          {ADDR}
          <a href="{googleMapNav}" class="d-inline-block mx-3" target="_blank" rel="noopener noreferrer">
            <i class="icon icon-pin mr-2"></i>取得路線
          </a>
          </p>
          <p class="mb-0">{TEL}</p>
        </div>
        </article>
        <article>
        {CARview}
        {INTERESTview}
        {CONSTELLATIONview}
        {ZODIACview}
        <article>
        <header>自我介紹</header>
        <div>
          <p>
          {INFO}
          </p>
        </div>
        </article>
        {IMAGEVIDEO}
      </div>
      </div>
    </div>
    <div class="tab-pane fade" id="cases{SNO}" role="tabpanel" aria-labelledby="cases-tab{SNO}">
      <div class="sale-modal-text">
      <div class="sale-modal-scroll-pc popup-scroll d-inline-block">
        {CASEview}
      </div>
      </div>
    </div>
    </div>
  </div>
  </div>
  <div class="sale-modal-btn">
  <a href="{FACEBOOK}" target="_blank" id="sale-fb-m" class="btn btn-icon-big btn-fb mx-2" data-sales="{EMP_NO} {NAM}">
    <i class="icon icon-FB"></i>
  </a>
  <a href="{LINE}" target="_blank" id="sale-line-m" class="btn btn-icon-big btn-line mx-2" data-sales="{EMP_NO} {NAM}">
    <i class="icon icon-LINE"></i>
  </a>
  {YTURLview}
  {IGURLview}
  <a href="tel:{VISUALPHONE}" id="sale-call-m" class="btn btn-icon-big btn-primary btn-phone mx-2" data-sales="{EMP_NO} {NAM}">
    <i class="icon icon-telphone"></i>
    <span class="ml-2 sale-call-content" style="display:none">{VISUALPHONE}</span>
  </a>
  <a href="javascript:;" class="sale-share-m btn btn-icon-big btn-share mx-2" data-sales="{EMP_NO} {NAM}">
    <img class="icon-img" src="/images/cloud-sale/icon-share.svg"/>
    <span class="ml-2 d-none d-lg-inline">分享</span>
  </a>
  <a href="https://e-invitation.toyota.com.tw/invitation_cloud_sales.php?emp_no={EMP}" class="sale-gift-m btn btn-icon-big btn-gift mx-2" data-sales="{EMP_NO} {NAM}" target="_blank">
    <img class="icon-img" src="../images/cloud-sale/ic-gift.svg"/>
  </a>
  <div class="">
    <div class="sale-share-code text-center" style="display:none">
    <a href="javascript:;" class="link-icon-append close-button">
      <i class="icon-toyota icon-toyota-cross"></i>
    </a>
    <div class="icon-item icon-item-line">
      <a href="{LINESHARE}" target="_blank">
      <img src="/public/mock/cloud-sale/line.png" style="" alt="line" class="icon-image">
      </a>
      <div>Line</div>
    </div>
    <div class="icon-item icon-item-link">
      <a href="javascript:;">
        <img src="/public/mock/cloud-sale/link.png" style="" alt="link" class="icon-image">
      </a>
      <div>複製連結</div>
    </div>
    <div class="d-none d-lg-block">
      <img src="/" style="" alt="QRcode"  class="qrcode-image">
    </div>
    <div class="d-none d-lg-block">用Line掃描QRCode分享給好友</div>

    </div>
  </div>
  </div>
</div>
</div>
</div>`;
const titleHtml = `<article>
<header>{title}</header>
<div>
  <p>
  {view}
  </p>
</div>
</article>`;

// 形象影片連結
const videoHtml = `<article>
<header>形象影片</header>
  <div class="sale-video">
  <lite-youtube src="{IMAGEVIDEO}" params="playsinline=1&autohide=0&modestbranding=1&fs=0&enablejsapi=1&controls=1&rel=0&autoplay=0">
  </lite-youtube>
</div>
</article>`;

const topHtml = '<div class="recommend-tag">人氣推薦</div>';
const noTopHtml = '<div class="recommend-tag-spacer"></div>';

const hasCaseSpacHtml = '<div class="spacer"></div>';

const hasCaseTabHtml = `<ul class="nav nav-tabs sale-tabs" id="tab{SNO}" role="tablist">
<li class="nav-item" role="presentation">
<a class="nav-link active" id="about-tab{SNO}" data-toggle="tab" href="#about{SNO}" role="tab" aria-controls="about{SNO}" aria-selected="true">關於我</a>
</li>
<li class="nav-item" role="presentation">
<a class="nav-link" id="cases-tab{SNO}" data-toggle="tab" href="#cases{SNO}" role="tab" aria-controls="cases{SNO}" aria-selected="false">數位服務優秀案例</a>
</li>
</ul>`;
const noCaseTabHtml = '<div class="pl-4 d-none d-md-inline"></div>';

const casesHtml = `<div class="sale-modal-case">
<article>
<img src="{IMAGENURL}" alt="案例圖片">
</article>
<article>
<header>成交車款</header>
<div>
  <p>
  {DEAL_CARview}
  </p>
</div>
</article>
<article>

<article>
<header>成交心得</header>
<div>
  <p>
  {REMARKS}
  </p>
</div>
</article>

<header>成交時間</header>
<div>
  <p>
  {DEAL_DATview}
  </p>
</div>
</article>
</div>`;

const ytHtml = `<a href="{YTURL}" target="_blank"  id="sale-youtube-m" class="btn btn-icon-big btn-youtube mx-2" data-sales="{EMP_NO} {NAM}">
<img src="/images/cloud-sale/icon-youtube.svg"/>
</a>`;
const igHtml = `<a href="{IGURL}" target="_blank" id="sale-ig-m" class="btn btn-icon-big btn-ig mx-2" data-sales="{EMP_NO} {NAM}">
<img src="/images/cloud-sale/icon-ig.svg"/>
</a>`;

const lineShareUrl = 'line://msg/text/';
const shareTitle = '推薦給您TOYOTA官方精選的雲端銷售顧問，點入可了解更多喔！';
const defalutCity = '請選擇縣市';
let citys = [];
let shops = [];
let salesTemp = [];
let typ = 0;
let pageIndex = 0;
const pageSize = 12;
let isChangeRenarks = false;
let isNoData = false;
const nearShopCount = 3; // 最近據點取前三個接近的營業所
const RANGE = 1000; // 距離
let param = ''; // 參數

let isSmoke = '';
let types = [];
// 紀錄最後一次的request，以便改變進階篩選
let tmpRequest = {
  typ: 0, codes: '', isSmoke: '', types: [], zone: '', city: '',
};

function fancyboxSaleData() {
  const fancyboxDefaults = {
    buttons: [
      'close',
    ],
    mobile: {
      touch: true,
    },
    touch: {
      vertical: false,
      momentum: true,
    },
    toolbar: true,
    backFocus: false,
    baseClass: 'figure-slide',
    infobar: false,
    animationEffect: 'fade',
    transitionEffect: 'slide',
    // clickContent(current) {
    //   if (current.type === 'image') {
    //     return false;
    //   }
    // },
    caption() {
      return $(this).find('figcaption').html();
    },
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">'
        + '<i class="icon icon-close"></i>'
        + '</button>',
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
    },
    onInit() {
      // console.log(instance);
      if ($.fancybox.isMobile) {
        const a = $('body,html').scrollTop() * -1;
        $('body,html').css('top', a).addClass('fancybox-iosfix');
        // console.log(a)
      }
    },
    afterClose() {
      let offset;
      if ($('body,html').hasClass('fancybox-iosfix')) {
        offset = parseInt(document.body.style.top, 10);
        $('body,html').removeClass('fancybox-iosfix').css('top', '').scrollTop(offset * -1);
      }
      $('.sale-call-content').hide();
      console.log('122');
    },
  };
  $('[data-fancybox="sale-data"]').fancybox(fancyboxDefaults);
}

function fancyboxFilter() {
  const fancyboxDefaults = {
    buttons: [
      'close',
    ],
    mobile: {
      touch: false,
    },
    touch: {
      vertical: false,
      momentum: true,
    },
    idleTime: false, // 不自動隱藏按鈕
    toolbar: true,
    backFocus: false,
    baseClass: 'figure-slide',
    infobar: false,
    animationEffect: 'fade',
    transitionEffect: 'slide',
    loop: false,
    arrows: false,
    // clickSlide: false,
    // caption() {
    //   return $(this).find('figcaption').html();
    // },
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">'
        + '<i class="icon icon-close"></i>'
        + '</button>',
    },
    onInit() {
      // console.log(instance);
      if ($.fancybox.isMobile) {
        const a = $('body,html').scrollTop() * -1;
        $('body,html').css('top', a).addClass('fancybox-iosfix');
        // console.log(a)
      }
    },
    afterClose() {
      let offset;
      if ($('body,html').hasClass('fancybox-iosfix')) {
        offset = parseInt(document.body.style.top, 10);
        $('body,html').removeClass('fancybox-iosfix').css('top', '').scrollTop(offset * -1);
      }
    },
    beforeClose() {
      const menuClass = '.clouldpoup';
      const src = '#modal-filter';
      // 判斷 checkbox 是否選取
      if (types.length !== 0) {
        $(`${menuClass} .scroll-menu [data-src="${src}"]`).addClass('checked');
        $(`${menuClass} .scroll-menu [data-src="${src}"]`).addClass('active');
      } else {
        $(`${menuClass} .scroll-menu [data-src="${src}"]`).removeClass('checked');
        $(`${menuClass} .scroll-menu [data-src="${src}"]`).removeClass('active');
      }
    },
  };
  $('[data-fancybox="filter-data-pc"]').fancybox(fancyboxDefaults);
  $('[data-fancybox="filter-data-mobile"]').fancybox(fancyboxDefaults);
}

function dynamicSort(argProperty) {
  let sortOrder = 1;
  let property = argProperty;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function sort(a, b) {
    let result;// = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    if ((a[property] < b[property])) {
      result = -1;
    } else if ((a[property] > b[property])) {
      result = 1;
    } else {
      result = 0;
    }
    return result * sortOrder;
  };
}

function getDistance(lat1, lon1, lat2, lon2) {
  const deg2rad = Math.PI / 180;
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad * (lat2 - lat1); // deg2rad below
  const dLon = deg2rad * (lon2 - lon1);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
            + Math.cos(deg2rad * lat1) * Math.cos(deg2rad * lat2)
            * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
}

function getCurrentPosition() {
  return new Promise((resolve) => {
    if ('geolocation' in navigator) {
      setTimeout(() => {
        resolve(null);
      }, 1000); // 1秒後取不到定位，回傳null
      navigator.geolocation.getCurrentPosition((position) => {
        resolve(position);
      });
    } else {
      resolve(null);
    }
  });
}

/**
 * @description 顯示/隱藏 scroll 提示
 */
function handleScrollHint($this) {
  const newScrollTop = $this.scrollTop();
  const scrollHint = $this.find('.scroll-hint');
  if (newScrollTop > 30) {
    scrollHint.addClass('hide');
  } else {
    scrollHint.removeClass('hide');
  }
}

/**
 * @description 顯示/隱藏 modal上方tab
 */
let oldScrollTop = 0;
function handleTabShow($this) {
  const newScrollTop = $this.scrollTop();
  const tab = $this.find('.sale-tabs');
  const spacer = $this.find('.spacer');

  const contentHeight = $this.find('.tab-content').height();
  const thisHeight = $this.height();
  if (newScrollTop + thisHeight + 50 > contentHeight) { // 處理 safari 滑到底會回彈
    return;
  }
  if (oldScrollTop < newScrollTop && oldScrollTop > 0) { // 往下滑
    tab.css({ 'margin-top': '-2.5rem' });
    spacer.css({ 'margin-top': '-2.5rem' });
  } else { // 往上
    tab.css({ 'margin-top': '0' });
    spacer.css({ 'margin-top': '0' });
  }
  oldScrollTop = newScrollTop;
}

async function setHtml(datas, argisChangeRenarks, isAppend) {
  let salesDataHtml = '';
  let dataitem = null;
  const current = await getCurrentPosition(); // 取得定位
  datas.forEach((item) => {
    dataitem = item;
    if (argisChangeRenarks) {
      if (item.RENARKS === '無') {
        dataitem.RENARKS = '';
      } else {
        const renarks = item.RENARKS.split(',');
        let html = '';
        renarks.forEach((r) => {
          html += `<li class="tag">${r}</li>`;
        });
        dataitem.RENARKS = html;
      }
    }
    if (item.IMG_LNK === '' || item.IMG_LNK === null || item.IMG_LNK === 'null') {
      dataitem.IMG_LNK = '/public/mock/cloud-sale/salesperson.jpg';
    }
    let mapData = null;
    const shop = shops.find((x) => x.BRANCH_CODE === item.BRANCH_CODE);
    if (current != null) {
      mapData = { googleMapNav: `https://www.google.com/maps/dir/${current.coords.latitude},${current.coords.longitude}/${shop.LATITUDE},${shop.LONGITUDE}` };
    } else {
      mapData = { googleMapNav: `https://www.google.com/maps/search/?api=1&query=${shop.LATITUDE},${shop.LONGITUDE}` };
    }
    if (item.VISUALPHONE === 'null' || item.VISUALPHONE === null) {
      dataitem.VISUALPHONE = '';
    }

    if (item.IMAGEVIDEO === 'null' || item.IMAGEVIDEO === null) {
      dataitem.IMAGEVIDEO = '';
    } else {
      let youtobehtml = '';
      youtobehtml = videoHtml.format(dataitem);
      dataitem.IMAGEVIDEO = youtobehtml;
    }
    dataitem.CARview = '';
    if (item.CARS.length > 0) {
      dataitem.CARview = titleHtml.format({ title: '駕駛車款', view: item.CARS.join(',') });
    }
    dataitem.INTERESTview = '';
    if (item.INTERESTS.length > 0) {
      dataitem.INTERESTview = titleHtml.format({ title: '個人興趣', view: item.INTERESTS.join(',') });
    }
    dataitem.CONSTELLATIONview = '';
    if (item.CONSTELLATIONS && item.CONSTELLATIONS.length > 0) {
      dataitem.CONSTELLATIONview = titleHtml.format({ title: '星座', view: item.CONSTELLATIONS.join(',') });
    }
    dataitem.ZODIACview = '';
    if (item.ZODIACS && item.ZODIACS.length > 0) {
      dataitem.ZODIACview = titleHtml.format({ title: '生肖', view: item.ZODIACS.join(',') });
    }
    const urlCould = `${lineShareUrl}${shareTitle}${window.location.origin}/cloud_sale.aspx?query=${encodeURIComponent(item.NAM)}`;
    dataitem.LINESHARE = urlCould;
    // 人氣
    dataitem.TOPview = noTopHtml;
    if (item.ISTOP === 'Y') {
      dataitem.TOPview = topHtml;
    }
    dataitem.YTURLview = '';
    if (item.YTURL !== 'null' && item.YTURL !== null) {
      dataitem.YTURLview = ytHtml.format(item);
    }
    dataitem.IGURLview = '';
    if (item.IGURL !== 'null' && item.IGURL !== null) {
      dataitem.IGURLview = igHtml.format(item);
    }
    // 是否有case
    dataitem.CASEspec = '';
    dataitem.CASEtabview = noCaseTabHtml;
    dataitem.CASEview = '';
    if (item.CASE.length > 0) {
      dataitem.CASEspec = hasCaseSpacHtml;
      dataitem.CASEtabview = hasCaseTabHtml.format(dataitem);
      item.CASE.forEach((caseItem) => {
        dataitem.CASEview += casesHtml.format(caseItem);
      });
    }
    salesDataHtml += salesHtml.format(dataitem);
    salesDataHtml = salesDataHtml.format(mapData);
  });
  $('#title-count').show();
  if (isAppend) {
    $('#salesContents').append(salesDataHtml);
  } else {
    $('#salesContents').html(salesDataHtml);
  }
  fancyboxSaleData(); // 動態物件需fancybox 動態更新
  $('#count').html(salesTemp.length);

  $('.sale-modal-scroll').on('scroll', function handelModalScroll() {
    handleScrollHint($(this));
    handleTabShow($(this));
  });
}

function setHtmlForPageSize(datas, argisChangeRenarks, isAppend) {
  const pageData = datas.slice(pageIndex * pageSize, (pageIndex * pageSize) + pageSize);
  if (pageData.length < pageSize) {
    isNoData = true;
  }
  setHtml(pageData, argisChangeRenarks, isAppend);
}

function getData(request) {
  if (request.typ != null) {
    tmpRequest = request;
  } else {
    tmpRequest.isSmoke = request.isSmoke;
    tmpRequest.types = request.types;
  }
  // tmpRequest.typefilter = JSON.stringify(request.types);

  $('#count').html('');
  $.ajax({
    url: '/api/cloud-sales.ashx',
    type: 'POST',
    dataType: 'json',
    data: tmpRequest,
    success: (result) => {
      if (result.returnCode === '0000') {
        salesTemp = result.datas;
        isNoData = false;
        // 增加 下拉讀取效果
        pageIndex = 0;
        isChangeRenarks = true;
        setHtmlForPageSize(result.datas, true, false);
        // 參數帶關鍵字查詢
        // 回傳筆數結果為1時自動poup
        if (request.typ === 2 && param === $('#searchText').val() && result.datas.length === 1) {
          setTimeout(() => {
            $('[data-fancybox="sale-data"]').first().trigger('click');
          }, 1000);
        }
      }
    },
  }).fail((e) => {
    console.log('error', e);
  });
}

function getCitys() {
  $.ajax({
    url: '/api/cloud-sales-citys.ashx',
    type: 'POST',
    dataType: 'json',
    data: {},
    success: (result) => {
      if (result.returnCode === '0000') {
        citys = result.datas;
        shops = result.shops;
        let carList = `<option value="">${defalutCity}</option>`;
        result.datas.forEach((item) => {
          carList += cityHtml.format(item);
        });
        $('#city').html(carList);

        // 取得縣市與營業所座標資料後才開始取得目前位置
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            // 計算營業所與定位點的距離
            shops.forEach((item) => {
              // eslint-disable-next-line no-param-reassign
              item.dist = Math.round(getDistance(
                item.LATITUDE,
                item.LONGITUDE,
                position.coords.latitude,
                position.coords.longitude,
              ));
            });
          });
        }

        if (param !== '' && param !== null && param !== undefined) {
          $('#search').trigger('click');
        } else {
          // 拿完縣市資料後拿預設資料
          typ = 4;
          getData({ typ: 4, isSmoke, types });
        }
      }
    },
  }).fail((e) => {
    console.log('error', e);
  });
}

function changeCheckValue() {
  isSmoke = $('#modal-filter').find('input[id=noSmoke]').prop('checked') ? 'N' : '';
  types = [];
  $('#modal-filter').find('input[name=eventCategoryLang]:checked')
    .each((i, e) => {
      const tagCheckeds = $(e).closest('.custom-checkbox').find('.tag.checked');
      if (tagCheckeds.length > 0) {
        tagCheckeds.each((ti, te) => types.push({ TYP: $(e).attr('typ'), CODE: $(te).attr('code') }));
      } else {
        types.push({ TYP: $(e).attr('typ'), CODE: $(e).attr('code') });
      }
    });
}

function showSearch() {
  $('#title-recommend').addClass('d-none');
  $('#title-count').removeClass('d-none');
  $('.show-more').removeClass('d-none');
  $('header.section-register-subhead').addClass('border-bottom-0 pb-0');
  $('#locationSearchCloud').addClass('pt-0');
}

function hideSearch() {
  $('#title-recommend').removeClass('d-none');
  $('#title-count').addClass('d-none');
  $('.show-more').addClass('d-none');
  $('header.section-register-subhead').removeClass('border-bottom-0 pb-0');
  $('#locationSearchCloud').removeClass('pt-0');
}

function showPopup() {
  const menuClass = '.clouldpoup';

  // 搜尋
  $('.sale-modal-scroll-filter a.save').click(() => {
    const src = '#modal-filter';

    changeCheckValue();
    // 判斷 checkbox 是否選取
    if (types.length !== 0) {
      $(`${menuClass} .scroll-menu [data-src="${src}"]`).addClass('checked');
      $(`${menuClass} .scroll-menu [data-src="${src}"]`).addClass('active');
      showSearch();
    } else {
      $(`${menuClass} .scroll-menu [data-src="${src}"]`).removeClass('checked');
      $(`${menuClass} .scroll-menu [data-src="${src}"]`).removeClass('active');
    }
    $.fancybox.close();
    getData({ isSmoke, types });
    if (typ === 4 && isSmoke === '' && types.length === 0) {
      hideSearch();
    }
  });
  // checkbox change
  $('.sale-modal-scroll-filter input').change(function checkL() {
    // 檢查group 顯示
    const groupTitle = $(this).closest('.card').find('h4');
    const groupCheckLength = $(this).closest('.collapse').find('input:checked').length;
    if (groupCheckLength > 0) {
      groupTitle.addClass('checked');
    } else {
      groupTitle.removeClass('checked');
    }

    // 檢查全部check disabled 移除
    const checkLegth = $('.sale-modal-scroll-filter input:checked').length;
    if (checkLegth > 0) {
      $('.sale-modal-scroll-filter a.remove').removeClass('disabled');
    } else {
      $('.sale-modal-scroll-filter a.remove').addClass('disabled');
    }
  });

  // 清除
  $('.sale-modal-scroll-filter a.remove').click(() => {
    $('.sale-modal-scroll-filter input:checked')
      .prop('checked', false);
    $('.sale-modal-scroll-filter .card h4').removeClass('checked');
    $('.custom-checkbox .tag').removeClass('checked');
    isSmoke = '';
    types = [];
  });
}

function copyToClipboard(textToCopy) {
  // navigator clipboard 需要https
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(textToCopy);
    alert('連結已複製!');
    return;
  }
  // http 適用
  const textArea = document.createElement('textarea');
  textArea.value = textToCopy;
  // 建置暫存容器
  textArea.style.position = 'absolute';
  textArea.style.opacity = 0;
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  textArea.setSelectionRange(0, textArea.value.length);
  document.execCommand('copy');
  alert('連結已複製!');
}

export function initDatas() {
  param = getURLParameter('query');
  $('#searchText').val(param);

  // share
  $('body').on('click', '.sale-share-m', function click() {
    const $this = $(this);
    $this.closest('.sale-modal').find('.sale-share-code').show();

    const cloudName = $this.closest('.sale-modal').attr('name');
    const qrcode = $this.closest('.sale-modal').find('.qrcode-image');
    const opts = {
      errorCorrectionLevel: 'H',
      type: 'image/jpeg',
      quality: 0.3,
      margin: 1,
    };
    const urlorgin = `${shareTitle}${window.location.origin}/cloud_sale.aspx?query=${cloudName}`;
    const urlCould = `${lineShareUrl}${encodeURIComponent(urlorgin)}`;
    QRCode.toDataURL(urlCould, opts, (err, url) => {
      qrcode.attr('src', url);
    });
  });

  $('body').on('click', '.sale-share-code .close-button', () => {
    $('.sale-share-code').hide();
  });

  // const urlCould = `${lineShareUrl}${window.location.origin}/cloud_sale.aspx?query=${encodeURIComponent(cloudName)}`;
  $('body').on('click', '.icon-item-link', function click() {
    const $this = $(this);
    const cloudName = $this.closest('.sale-modal').attr('name');
    const url = `${window.location.origin}/cloud_sale.aspx?query=${cloudName}`;
    copyToClipboard(url);
  });

  // phone
  $('body').on('click', '.btn-phone', function click() {
    // console.log('test');
    const $this = $(this);
    const wW = $(window).width();
    if (wW >= 1024) {
      $this.closest('.sale-modal').find('.sale-call-content').show();
    } else {
      $this.closest('.sale-modal').find('.sale-call-content').hide();
    }
  });

  showPopup();
  $('.offers-loading').hide();
  let scrollOld = 0;
  let scrollNew = 0;
  let isDown = false;
  let isloading = false;
  $(window).scroll(function scroll() {
    const scrollTop = $(this).scrollTop();
    scrollOld = scrollNew;
    scrollNew = scrollTop;

    // 判斷是向上滑還是向下
    if (scrollNew > scrollOld) {
      isDown = true;
    } else {
      isDown = false;
    }

    const windowHeight = $(this).height();
    const height = scrollTop + windowHeight - $('.main-wrapper').height();
    if (isDown && height > 0 && height < 100 && !isloading && !isNoData) { // 判斷是不是滑到內容視窗的底部
      isloading = true;
      $('.offers-loading').show();
      setTimeout(() => {
        pageIndex += 1;
        setHtmlForPageSize(salesTemp, isChangeRenarks, true);
        isloading = false;
        $('.offers-loading').hide();
      }, 200);
    }
  });
  $('#title-count').hide();
  getCitys();

  $('#getGeoLocation').on('click', () => {
    typ = 0;
    const filterShops = shops.filter((x) => x.dist <= RANGE);
    if (filterShops.length > 0) {
      filterShops.sort(dynamicSort('dist'));
      const finalShops = filterShops.slice(0, nearShopCount);
      getData({
        typ: 0, codes: finalShops.map((x) => x.BRANCH_CODE).join(','), isSmoke, types,
      });
    } else {
      alert('附近沒有可使用的據點');
    }
  });
  $(document).on('click', '.sale-link', function click() {
    const id = $(this).attr('data-Id');
    $.ajax({
      url: '/api/cloud-sales.ashx',
      type: 'POST',
      dataType: 'json',
      data: { typ: 9, sno: id },
      success: (result) => {
        console.log(result);
      },
    }).fail((e) => {
      console.log('error', e);
    });
  });

  $('#reSet').on('click', () => {
    getData({ isSmoke, types });
  });
  $('#reSearch').on('click', () => {
    // $('#zone').val(null).trigger('change');
    $('#searchText').val('');
    $('.sale-modal-scroll-filter a.remove').trigger('click');
    $('.clouldpoup .scroll-menu [data-src]').removeClass('checked');
    $('#city').val(null).trigger('change');
  });

  $('#search').on('click', () => {
    typ = 2;
    const txt = $('#searchText').val();
    if (txt === '' || verityInput(txt, 'htmltag') === false) {
      alert('請輸入關鍵字');
    } else {
      getData({
        typ: 2, txt, isSmoke, types,
      });
      showSearch();
    }
  });
  $('#zone').on('change', function change() {
    if ((this.value === '' || this.value === null) && $('#city').val() === '') {
      isChangeRenarks = false;
      pageIndex = 0;
      isNoData = false;
      setHtmlForPageSize(salesTemp, false, false);
    } else if (this.value === '') {
      typ = 1;
      getData({
        typ: 1, city: $('#city').val(), isSmoke, types,
      });
      showSearch();
    } else {
      typ = 3;
      getData({
        typ: 3, zone: this.value, city: $('#city').val(), isSmoke, types,
      });
      showSearch();
    }
  });
  $('#city').on('change', function change() {
    typ = 1;
    $('#zone').prop('disabled', this.value === '' ? 'disabled' : false);
    if (this.value !== '' && this.value !== null) {
      const { areas } = citys.find((x) => x.city === this.value);
      let areaList = '<option value="">請選擇區域</option>';
      areas.forEach((item) => {
        if (item.area !== '') {
          areaList += areaHtml.format(item);
        }
      });
      $('#zone').html(areaList);

      getData({
        typ: 1, city: this.value, isSmoke, types,
      });

      showSearch();
    } else {
      $('#zone').val(null).trigger('change');
      typ = 4;
      getData({ typ, isSmoke, types });
      if (isSmoke === '' && types.length === 0) {
        hideSearch();
      }
    }
  });

  $('.custom-checkbox .tag').on('click', function click() {
    const $this = $(this);
    const otherSiblings = $this.siblings().hasClass('checked');
    const checkbox = $this.closest('.custom-checkbox').find('input');
    $this.toggleClass('checked');
    if ($this.hasClass('checked') && !otherSiblings) {
      // 檢查 是否需要取消group勾選
      checkbox.prop('checked', true);
      checkbox.trigger('change');
    } else if (!otherSiblings) {
      // 檢查 是否需要勾選group
      checkbox.prop('checked', false);
      checkbox.trigger('change');
    }
  });

  $('#feature_content_car input').on('click', function click() {
    const $checkbox = $(this);
    const tags = $checkbox.closest('.custom-checkbox').find('.tag');
    const checked = $(this).prop('checked');
    if (checked) {
      tags.addClass('checked');
    } else {
      tags.removeClass('checked');
    }
  });

  fancyboxFilter();
}

export default {
  initDatas,
};
